import BaseIcon from './components/BaseIcon';
import Loader from './components/Loader';

const Icon = BaseIcon;

Icon.Loader = Loader;

export default Icon;
